import CoreAPI from '../Core/CoreAPI';
import { getSessionItem } from '../Enviroments/EnvironmentsService';
class FirebaseAuthAPI {
  constructor() {
    this.setApi(new CoreAPI(getSessionItem('API_IDENTITY_SERVER')));
  }

  setApi(api) {
    this.api = api;
  }

  getAPI() {
    if (!this.api.baseURL) this.setApi(new CoreAPI(getSessionItem('API_IDENTITY_SERVER')));

    return this.api;
  }

  async postAutentication() {
    const result = await this.getAPI().getInstance().post('/api/Account/v1/firebase/token');

    return result;
  }
}

const api = new FirebaseAuthAPI();
export default api;
